<template>
  <v-row>
    <v-col>
      <v-card class="elevation-4" rounded="lg">
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-chart-line</v-icon>
          <span class="text-h6">Frequência Mensal</span>
        </v-card-title>

        <v-card-text class="pa-4">
          <LineChartGenerator
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
          />
        </v-card-text>

        <v-card-actions class="pa-3 grey lighten-4">
          <v-btn color="primary" text depressed @click="show = !show">
            <v-icon left>mdi-information-outline</v-icon>
            Como interpretar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn icon @click="show = !show" color="primary">
            <v-icon>{{ show ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <div v-show="!show">
            <v-divider></v-divider>

            <v-card-text class="info-box">
              <v-icon color="primary" class="mr-2">mdi-chart-line-stacked</v-icon>
              <span class="text-subtitle-2 primary--text">Sobre este gráfico:</span>

              <ul class="mt-2 pl-4">
                <li>
                  Demonstra a quantidade de faltas e presenças por mês.
                  <br /><span class="text-caption grey--text"
                    >Calculado com base nas aulas realizadas na turma do aluno.</span
                  >
                </li>
                <li class="mt-2">
                  Passe o cursor sobre os pontos para ver os valores exatos.
                  <br /><span class="text-caption grey--text"
                    >Pontos azuis: presenças | Pontos laranjas: faltas</span
                  >
                </li>
              </ul>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  watch: {
    data: {
      handler(value) {
        this.chartData.labels = value.meses;
        this.chartData.datasets = [value.faltas, value.presencas];
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        meses: [],
        faltas: [],
        presencas: [],
      }),
    },
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 260,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
      chartData: {
        labels: this.data.meses,
        data: [this.data.faltas, this.data.presencas],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
            labels: {
              font: {
                size: 12,
                family: "Roboto",
              },
              padding: 20,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            backgroundColor: "#424242",
            titleFont: {
              size: 14,
              family: "Roboto",
              weight: "bold",
            },
            bodyFont: {
              size: 12,
              family: "Roboto",
            },
            padding: 12,
            cornerRadius: 4,
            displayColors: true,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              font: {
                family: "Roboto",
              },
            },
            grid: {
              drawBorder: false,
              color: "rgba(0,0,0,0.05)",
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              font: {
                family: "Roboto",
              },
            },
          },
        },
      },
    };
  },
};
</script>

<style scoped>
.info-box {
  background-color: #f5f5f5;
  border-left: 4px solid var(--v-primary-base);
}

.v-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.info-box ul li {
  margin-bottom: 8px;
  line-height: 1.5;
}
</style>
